module.exports = __webpack_public_path__ + "static/media/weight.d2f7167e.png";